import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AppSidebar } from '@/components/app-sidebar';
import ProductMapRoute from '@/routes/product-map';
import PriceListRoute from '@/routes/price-list';
import ReportRoute from '@/routes/report';
import SharedReportRoute from '@/routes/shared-report';
import AdminImportRoute from '@/routes/admin-import';
import { PlaceholderRoute } from '@/routes/placeholder';
import { getBrands, type BrandStat } from '@/lib/api';

export default function App() {
  const [brands, setBrands] = useState<BrandStat[]>([]);

  useEffect(() => {
    let cancelled = false;
    getBrands()
      .then((b) => !cancelled && setBrands(b))
      .catch((err) => console.error('Brands load failed:', err));
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public read-only share — KHÔNG sidebar, KHÔNG nav */}
        <Route path="/share/:token" element={<SharedReportRoute />} />

        {/* Internal layout — có sidebar + brands list */}
        <Route element={<AppLayout brands={brands} />}>
          <Route path="/" element={<ProductMapRoute brands={brands} onBrandsLoaded={setBrands} />} />
          <Route path="/table" element={<PriceListRoute brands={brands} onBrandsLoaded={setBrands} />} />
          <Route path="/report/:brand" element={<ReportRoute brands={brands} />} />
          <Route path="/admin/import" element={<AdminImportRoute />} />
          <Route path="*" element={<PlaceholderRoute title="404" description="Trang không tồn tại" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

function AppLayout({ brands }: { brands: BrandStat[] }) {
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebar brands={brands} className="hidden md:flex print:hidden" />
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
